import { render, staticRenderFns } from "./rcptPropertiesPanel.vue?vue&type=template&id=fd7a0e36"
import script from "./rcptPropertiesPanel.vue?vue&type=script&lang=js"
export * from "./rcptPropertiesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports